import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { AppBaseComponent } from '../../app-base.component';
import {
  BasicOrganizationUnitsDto,
  BasicOrganizationUnitsRequestDto,
  CareerCompetenciesOrganizationUnitService
} from '@proxy/organization-units';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-area-multi-selector',
    templateUrl: './area-multi-selector.component.html',
    standalone: false
})
export class AreaMultiSelectorComponent extends AppBaseComponent implements OnInit {
  @Input() isRequired: boolean;
  @Input() isSubArea = false;
  @Input() areasSelected: BasicOrganizationUnitsDto[];
  @Input() subAreasSelected: BasicOrganizationUnitsDto[];
  @Input() isDisabled = false;

  @Output() changeSelectedAreas = new EventEmitter<BasicOrganizationUnitsDto[]>();

  areas: BasicOrganizationUnitsDto[];
  selectedAreas: BasicOrganizationUnitsDto[];
  parentId = '';

  constructor(
    injector: Injector,
    private readonly _organizationUnitService: CareerCompetenciesOrganizationUnitService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.loadAreas();
  }

  async loadAreas(): Promise<void> {
    try {
      this.showLoading();

      if (this.isSubArea && this.isEmptyString(this.parentId)) {
        return;
      }

      const parentArea: BasicOrganizationUnitsRequestDto = {
        id: !this.isEmptyString(this.parentId) ? this.parentId : undefined
      };

      this.areas = (await firstValueFrom(this._organizationUnitService.getAllBasicAreasByParentArea(parentArea)))?.items;
      this.setSelectedAreas();
    } finally {
      this.hideLoading();
    }
  }

  async loadSubAreas(parents: BasicOrganizationUnitsDto[]): Promise<void> {
    if (!parents?.length) {
      return;
    }

    try {
      this.showLoading();

      this.isDisabled = false;
      this.areas = (await firstValueFrom(this._organizationUnitService.getSubAreasByParents(parents)))?.items ?? [];

      this.subAreasSelected = this.selectedAreas;
    
    } finally {
      this.hideLoading();
    }
  }

  onSelected(): void {
    this.changeSelectedAreas.emit(this.selectedAreas);
  }

  getLabel(): string {
    return this.isSubArea ? this.l('::SubArea') : this.l('::Area');
  }

  private setSelectedAreas(): void {
    if (this.areas?.length && this.areasSelected?.length) {
      this.selectedAreas = this.areasSelected;
      this.onSelected();
    }
  }
}
